export const FILES_ENDPOINTS = {
    GET_ALL: '/files',
    CREATE: '/files/create',
    GET_BY_ID: (id: string) => `/files/${id}`,
    DELETE: (id: string) => `/files/${id}`,
} as const;
